import { ISortInfo } from '../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import { getAttributeInfo } from '../../../../../../Model/avenyModelUtils';
import { collectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import { attributeDefToDataPath } from '../../../../../../Utils/dataUtils';
import { findFormatter } from '../../../../../../Utils/Formatters/FindFormatter';
import { IFormatter } from '../../../../../../Utils/Formatters/FormatterTypes';
import { IFilterAttribute } from '../../../Const/Delsystem';
import { ICollectionDataType } from '../../BusinessCollectionComponents/Queries/BusinessCollectionQuery';

const isNotRemoved = (item: ICollectionDataType) => !item['BORTTAGEN'];

const dataTreeFind = (
  data: Record<string, unknown>,
  path: string[],
  searchText: string,
  formatter: IFormatter,
  formatterDisplayParams: string
): boolean => {
  if (!data || path.length === 0) {
    return false;
  }
  if (path.length === 1) {
    const fieldValue = data[path[0]];
    if (typeof fieldValue === 'string') {
      const value = formatter
        ? formatter.displayer.display(
            fieldValue,
            true,
            formatterDisplayParams
          )
        : fieldValue;
      return value.toLowerCase().includes(searchText.toLowerCase());
    } else {
      return false;
    }
  }
  const nestedData = data[path[0]];
  if (nestedData && typeof nestedData === 'object') {
    return dataTreeFind(
      nestedData as Record<string, unknown>,
      path.slice(1),
      searchText,
      formatter,
      formatterDisplayParams
    );
  }
  const allData = data[path[0] + '_All'];
  if (Array.isArray(allData)) {
    return Boolean(
      allData.find((row: Record<string, unknown>) =>
        dataTreeFind(
          row,
          path.slice(1),
          searchText,
          formatter,
          formatterDisplayParams
        )
      )
    );
  }
  return false;
};

const matchesFilters = (
  row: ICollectionDataType,
  collectionName: string,
  searchText: string,
  filterAttributes: IFilterAttribute[]
): boolean => {
  const searchWords = searchText.split(' ');
  return (
    isNotRemoved(row) &&
    searchWords.every(word =>
      filterAttributes?.some(filterAttribute => {
        const { attribute } = getAttributeInfo(
          collectionName,
          filterAttribute.attribute,
          collectionMap
        );

        const formatter = findFormatter(
          attribute.Formatter,
          attribute.DataType
        );

        const pathVal = attributeDefToDataPath(filterAttribute.attribute);
        return dataTreeFind(
          row,
          pathVal,
          word,
          formatter,
          attribute.FormatterDisplayParams ?? ''
        );
      })
    )
  );
};

export const filterData = (
  collectionName: string,
  data: ISortInfo<ICollectionDataType>,
  searchText: string,
  filterAttributes: IFilterAttribute[] | undefined,
  urval: boolean,
  loading: boolean
): ISortInfo<ICollectionDataType> => {
  let filteredData: ISortInfo<ICollectionDataType> = {
    rows: [],
    properties: data.properties,
    filtered: !loading && Boolean(searchText || urval),
  };

  const filteredList = !filterAttributes
    ? data.rows.filter(isNotRemoved)
    : data.rows.filter(row =>
        matchesFilters(row, collectionName, searchText, filterAttributes)
      );
  if (filteredList.length > 0) {
    filteredData = {
      rows: filteredList,
      properties: data.properties,
      filtered: !loading && Boolean(searchText || urval),
    };
  }

  return filteredData;
};
